<script setup>
import { computed, ref } from "vue"

const props = defineProps(['type'])
const emits = defineEmits(['hide-window'])

const theText = computed(() => {
    if (props.type === 1) return 'New ship is unlocked!'
    if (props.type === 2) return 'New achievement is unlocked!'
    else return 'Try again'
    // else return 'New achievement is unlocked'
})
const opacity = ref(1)
const interval = setInterval(() => {
    if (opacity.value <= 0) {
        clearInterval(interval)
        emits('hide-window')
    } else
        opacity.value -= 0.01
}, 100)

</script>

<template>
 <div id="notification">
    <h5>{{ theText }}</h5>
 </div>
</template>

<style scoped>
#notification {
    position: absolute;
    width: fit-content;
    /* height: 100px; */
    top: 20px;
    right: 10px;
    /* transform: translate(-50%, -50%); */
    background-color: white;
    border: 3px solid aqua;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0 0 20px 20px black;
    opacity: v-bind(opacity);
    transition: opacity 1s;
}

#notification h5 {
    text-align: center;
    color: black;
    margin: 5px 0;
}

/* @media screen and (max-width: 1000px) {

    #notification {
        width: 250px;
        height: fit-content;
        left: calc(100% - 260px);
        transform: unset;
        top: 160px;
        overflow-y: auto;
        padding: 5px;
    }
} */
</style>